export default {
    color: 'primary',
  }